var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.$t("compensationSelection.TcRefuseTitle")))]),_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('compensationSelection.TcRefuseContent'))}})]),_c('br'),_c('button',{staticClass:"cta",on:{"click":function($event){return _vm.dialog()}}},[_vm._v(_vm._s(_vm.$t("generic_ok")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }